import { createSlice } from '@reduxjs/toolkit';
import {database} from "../utils/firebase";

const initialState = {
  archiveData: null,
  patientData:null,
  archiveId:"",
  patientID:"",
  delegateData: null,
  doctorEmail:"",
}
let archiveListener= null;
let delegateListener= null;

const slice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    setArchiveData: (state, action) => {
      state.archiveData = action.payload
    },
    setPatientData: (state, action) => {
      state.patientData = action.payload
    },
    setArchiveID: (state, action) => {
      state.archiveId = action.payload
    },
    setDelegateData: (state, action) => {
      state.delegateData = action.payload
    },
    setPatientID: (state, action) => {
      state.patientID = action.payload
    },
    setDoctorEmail: (state, action) => {
      state.doctorEmail = action.payload
    },
  },
})

export const fetchArchiveOpenData = (archiveId) => async (dispatch) => {
  try {
    // Detach any legacy persistent listener still attached from an older build.
    if (archiveListener) {
      archiveListener.off()
      archiveListener = null
    }

    // One-shot reads instead of a persistent `.on('value')`. fetchArchiveOpenData is
    // dispatched on every chat/consultation navigation, so this archive + patient data
    // refreshes each time a chat is opened. The previous version attached a never-detached
    // listener on `/archiveConversations` (and orphaned a SECOND `/openconversations`
    // listener via reassignment) that re-downloaded the whole `/users/<patientID>` record
    // on EVERY conversation write — a primary Realtime Database download-egress driver and
    // the twin of the /delegateChats listener leak fixed in #9. Live chat messages already
    // come from ChatModule's `/conversations` listener, so this data need not be live.
    let archiveData
    const archiveSnap = await database.ref(`/archiveConversations/${archiveId}`).once('value')
    if (archiveSnap.exists()) {
      archiveData = archiveSnap.toJSON() || {}
    } else {
      const openSnap = await database.ref(`/openconversations/${archiveId}`).once('value')
      archiveData = openSnap.toJSON() || {}
    }

    const { patientID } = archiveData || {}

    dispatch(slice.actions.setArchiveID(archiveId || {}))
    dispatch(slice.actions.setPatientID(patientID || {}))
    dispatch(slice.actions.setArchiveData(archiveData || {}))

    if (patientID) {
      const patientSnap = await database.ref(`/users/${patientID}`).once('value')
      dispatch(slice.actions.setPatientData(patientSnap.toJSON() || {}))
    }
  } catch (e) {
    console.log(e)
  }
}
  export const fetchDelegateData = (archiveId) => async (dispatch) => {
  try {
    // Detach any legacy persistent listener that may still be attached.
    if (delegateListener) {
      delegateListener.off()
      delegateListener = null
    }

    // One-shot read instead of a persistent `.on('value')`. fetchDelegateData is
    // dispatched on every chat navigation (ChatModule archiveId change), so the data
    // is refreshed each time a chat is opened. Holding a live listener per opened chat
    // caused per-chat /delegateChats/<id> nodes to re-download on every write — the
    // primary Realtime Database download-egress driver.
    const delegateSnapshot = await database.ref(`/delegateChats/${archiveId}`).once('value')
    const delegateConversationsData = delegateSnapshot.toJSON() || {}

    const { doctorID } = delegateConversationsData
    const delegateData = { ...delegateConversationsData, id: archiveId }

    if (doctorID) {
      const doctorSnap = await database.ref(`/doctors/${doctorID}/email`).once('value')
      dispatch(slice.actions.setDoctorEmail(doctorSnap.toJSON() || {}))
    }

    dispatch(slice.actions.setDelegateData(delegateData || {}))
  } catch (e) {
    console.log(e)
  }
}
export const actions = {
  ...slice.actions,
  fetchArchiveOpenData,
  fetchDelegateData
}
export default slice.reducer;

